var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36035 16.9058C12.7786 16.9058 16.3604 13.324 16.3604 8.90576C16.3604 4.48748 12.7786 0.905762 8.36035 0.905762C3.94207 0.905762 0.360352 4.48748 0.360352 8.90576C0.360352 13.324 3.94207 16.9058 8.36035 16.9058Z",
    fill: "#14AE5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86277 12.8074L2.93691 9.67582C2.53634 9.2471 2.55933 8.5688 2.98806 8.16823C3.41678 7.76767 4.09508 7.79072 4.49565 8.21938L6.75253 10.6349L10.3249 7.29712C10.357 7.26707 10.3906 7.23954 10.4253 7.21422L12.1052 5.64464C12.5339 5.24408 13.2123 5.26713 13.6128 5.69586C14.0134 6.12452 13.9903 6.80288 13.5617 7.20345L8.43071 11.9975L8.42523 11.9916L6.65036 13.6499L5.86277 12.807V12.8074Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.ce199ab209383ea3f79994bab7ccdc4e.svg";
export { ForwardRef as ReactComponent };